import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-4 container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "mt-4 mb-4 col-lg-3 col-sm-6 mt-sm-0" }
const _hoisted_6 = { class: "card h-100" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "mb-1 text-sm text-secondary fa fa-plus",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createElementVNode("h5", { class: "text-secondary" }, "Novos Pedidos")
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "mt-4 mb-4 col-lg-3 col-sm-6 mt-sm-0" }
const _hoisted_10 = { class: "card h-100" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "mb-1 text-sm text-secondary fa fa-plus",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createElementVNode("h5", { class: "text-secondary" }, "Novas Rotas")
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "row" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "row mt-4" }
const _hoisted_16 = { class: "col-lg-7 mb-lg-0 mb-4" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "p-3 pb-0 card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h6", { class: "mb-2" }, "Rotas de Hoje")
  ])
], -1)
const _hoisted_19 = { class: "table-responsive" }
const _hoisted_20 = { class: "table align-items-center" }
const _hoisted_21 = { class: "w-30" }
const _hoisted_22 = { class: "px-2 py-1 d-flex align-items-center" }
const _hoisted_23 = { class: "ms-4" }
const _hoisted_24 = { class: "mb-0 text-sm" }
const _hoisted_25 = { class: "badge badge-sm bg-gradient-success" }
const _hoisted_26 = {
  key: 0,
  class: "badge badge-sm bg-gradient-success"
}
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-0 text-sm" }, null, -1)
const _hoisted_30 = { class: "text-center" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-xs font-weight-bold" }, "Serviços:", -1)
const _hoisted_32 = { class: "mb-0 text-sm" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { class: "text-sm align-middle" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center col" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-xs font-weight-bold" }),
    /*#__PURE__*/_createElementVNode("h6", { class: "mb-0 text-sm" })
  ])
], -1)
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { class: "text-sm align-middle" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-sm bg-gradient-warning" }, "Nenhuma rota criada Hoje")
], -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "col-lg-5" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card = _resolveComponent("card")!
  const _component_incidentes_card = _resolveComponent("incidentes-card")!
  const _component_atrasados_card = _resolveComponent("atrasados-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goPedidos())),
                class: "text-center p-3 d-flex flex-column justify-content-center"
              }, _hoisted_8)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goRotas())),
                class: "text-center p-3 d-flex flex-column justify-content-center"
              }, _hoisted_12)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dash.cards, (card, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-lg-3 col-md-6 col-12",
              value: 'cidade_'+index
            }, [
              _createVNode(_component_card, {
                title: card.title,
                value: card.value,
                percentage: card.percentage,
                iconClass: card.iconClass,
                iconBackground: card.iconBackground,
                detail: card.detail,
                directionReverse: ""
              }, null, 8, ["title", "value", "percentage", "iconClass", "iconBackground", "detail"])
            ], 8, _hoisted_14))
          }), 256))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("table", _hoisted_20, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rotas, (rota, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("h6", _hoisted_24, _toDisplayString(rota.name), 1)
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rota.Incidentes, (incidente, indexx) => {
                            return (_openBlock(), _createElementBlock("div", { key: indexx }, [
                              _createElementVNode("span", _hoisted_25, _toDisplayString(incidente.name), 1)
                            ]))
                          }), 128)),
                          (!rota.Incidentes)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Sem Incidentes"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("p", {
                              class: "mb-0 text-xs font-weight-bold",
                              innerHTML: _ctx.calculaConclusao(rota.Pedidos)
                            }, null, 8, _hoisted_28),
                            _hoisted_29
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_30, [
                            _hoisted_31,
                            _createElementVNode("h6", _hoisted_32, _toDisplayString(rota.Pedidos.length), 1)
                          ])
                        ]),
                        _hoisted_33
                      ]))
                    }), 128)),
                    (_ctx.rotas.length==0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_34, _hoisted_36))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_incidentes_card, {
              cardTitle: 'Últimos Incidentes' ,
              incidentes: _ctx.incidentes
            }, null, 8, ["incidentes"]),
            _createVNode(_component_atrasados_card, {
              cardTitle: 'Entregas Atrasadas' ,
              atrasados: _ctx.atrasados
            }, null, 8, ["atrasados"])
          ])
        ]),
        _hoisted_38
      ])
    ])
  ]))
}